import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  comments1: Yup.string().required("Required!"),
  comments2: Yup.string().required("Required!"),
  comments3: Yup.string().required("Required!"),
  comments4: Yup.string().required("Required!"),
});
